import moment from 'moment';
import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Statistic/Order/components/List';
import ListTotals from '#app/View/Statistic/Order/components/ListTotals';
import Search from '#app/View/Statistic/Order/components/Search';
import OrderDocumentEntryPoints from '#app/entrypoints/orderDocument';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { OrderDocumentStats, OrderDocumentType } from '#app/typings/orderDocument';
import { PaymentMethod } from '#app/typings/orderPayment';

export type Filters = {
  startDate?: string;
  endDate?: string;
  channels?: number[];
  types?: OrderDocumentType[];
  paymentMethods?: PaymentMethod[];
  shops?: number[];
};

const StatisticOrder: React.FC = () => {
  const { setFilters, filters, ...props } = useCollectionPaginated<OrderDocumentStats, Filters>(
    OrderDocumentEntryPoints.getStatistic,
    {
      filters: {
        startDate: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      },
      sorting: { sortName: 'createdAt', sortDirection: 'desc' },
    },
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Stats factures', context: 'Statistiques' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <ListTotals filters={filters} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default StatisticOrder;
